<template>
  <b-form-group
    label="Hizmet Kategorisi"
    label-for="id_service_categories"
  >
    <validation-provider
      #default="{ errors }"
      name="Hizmet Kategorisi"
      rules="required"
    >
      <v-select
        v-model="dataItem.id_service_categories"
        :options="dataList"
        label="title"
        :reduce="item => item.id"
        placeholder="Hizmet Kategorisi"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup,
} from 'bootstrap-vue'
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  name: 'CategoryCard',
  components: {
    BFormGroup,
    vSelect,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['serviceCategories/dataList']
    },
    dataItem() {
      return this.$store.getters['services/dataItem']
    },
  },
  created() {
    localize('tr')
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.$store.dispatch('serviceCategories/getDataList', {
        select: [
          'service_categories.id AS id',
          'service_categories.title AS title',
        ],
        where: {
          'service_categories.status': 1,
        },
      })
    },
  },
}
</script>
